import { combineReducers } from 'redux'

import profile from 'src/store/modules/caregiver/profile'
import accessRestrictions from 'src/store/modules/caregiver/accessRestrictions'
import gamification from 'src/store/modules/caregiver/gamification'

export default combineReducers({
  profile,
  accessRestrictions,
  gamification
})

export * from 'src/store/modules/caregiver/profile'
export * from 'src/store/modules/caregiver/accessRestrictions'
export * from 'src/store/modules/caregiver/gamification'
